/* Native details remain usable without JavaScript and in Theme Editor. */
document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  const menu = document.querySelector(".pr-mobile-menu[open]");
  if (menu) {
    if (window.prSetDisclosure) window.prSetDisclosure(menu, false); else menu.open = false;
    menu.querySelector("summary")?.focus();
  }
});
document.addEventListener("click", (event) => {
  const menu = document.querySelector(".pr-mobile-menu[open]");
  if (menu && (!menu.contains(event.target) || event.target.closest("a, [data-pr-chat-open]")))
    if (window.prSetDisclosure) window.prSetDisclosure(menu, false); else menu.open = false;
});

/* Scope casual-save deterrents to marketing and product images only. */
(() => {
  const selector = 'main img, [data-protect-images] img, .product-media img, .product-card img';
  const protect = (root) => root.querySelectorAll(selector).forEach(image => {
    image.draggable = false;
    image.classList.add('pr-protected-image');
  });
  protect(document);
  document.addEventListener('shopify:section:load', event => protect(event.target));
  ['dragstart', 'selectstart'].forEach(type => {
    document.addEventListener(type, event => {
      if (event.target instanceof Element && event.target.matches(selector)) event.preventDefault();
    });
  });
})();

// Site-wide context menu blocking; clicks, scrolling and keyboard controls remain intact.
document.addEventListener('contextmenu', event => event.preventDefault());
